import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const createCustomer = async (data) => {
  const teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`${BASE_URL}/api/customers?team_id=${teamId}`, data, settings);
}

export const updateCustomer = async (data) => {
  let teamId = localStorage.getItem('current_team_id');
  let customerId = localStorage.getItem('customer_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`${BASE_URL}/api/customers?team_id=${teamId}&id=${customerId}`, data, settings)
}

export const getCustomers = async () => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${BASE_URL}/api/customers?team_id=${teamId}`, settings);
}

export const setNewCustomerOwner = async (data) => {
  let customerId = localStorage.getItem('customer_id');
  const settings = {
      headers: {
        'Authorization': `Bearer ${getAccessToken()}`
      }
  };

  return axios.patch(`${BASE_URL}/api/customer/owner?customer_id=${customerId}`, data, settings);
}

export const sentMessageToFuga = async (data) => {
  const teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`${BASE_URL}/api/notify`, data, settings)
}
